import { BusinessUnitSelectors, InjectorHelper, MetadataActions, MetadataSelectors, MetadataConstants } from 'invision-core';
export var loadSubscriberRequirements = function loadSubscriberRequirements() {
  var $ngRedux = InjectorHelper.getNgReduxService();
  var $q = InjectorHelper.getQService();
  var isDbss = BusinessUnitSelectors.IsDbss($ngRedux.getState());
  var requiredCodes = [MetadataConstants.codes.AdditionalProperty, MetadataConstants.codes.AdditionalPropertyValue, MetadataConstants.codes.AddressCountry, MetadataConstants.codes.BusinessUnitLanguageConfiguration, MetadataConstants.codes.DefaultPasswordChallenge, MetadataConstants.codes.Language, MetadataConstants.codes.PersonSuffix, MetadataConstants.codes.PersonTitle, MetadataConstants.codes.RegularExpression, MetadataConstants.codes.SubscriberType, MetadataConstants.codes.TermsAndConditionsConfiguration];
  var optionalCodes = {
    display_drivers_license_state: MetadataConstants.codes.AddressStateProvinceRegion,
    display_gender: MetadataConstants.codes.PersonGender,
    display_income_level: MetadataConstants.codes.SubscriberIncomeLevelType,
    display_race: MetadataConstants.codes.PersonRace,
    display_subscriber_lead_source: MetadataConstants.codes.SubscriberLeadSourceType
  };
  return function (dispatch) {
    var setRequirements = function setRequirements(requirements) {
      if (isDbss) {
        requiredCodes.push(MetadataConstants.codes.SubscriberCategoryDefaultSubscriberType);
      }
      for (var _i = 0, _Object$keys = Object.keys(optionalCodes); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (requirements[key]) {
          requiredCodes.push(optionalCodes[key]);
        }
      }
    };
    var fetchRequiredCodes = function fetchRequiredCodes() {
      var itemsToFetch = new Set(requiredCodes);
      itemsToFetch.forEach(function (code) {
        if (!MetadataSelectors.codes.MetadataCodeLoadedSelector(code)($ngRedux.getState())) {
          dispatch(MetadataActions.codes.fetchCodeTypes(code));
        }
      });
    };

    /* Pull in the subscriber requirements for the selected business unit */
    var promises = [MetadataActions.codes.fetchSubscriberRequirementsPromise(dispatch)];
    if (isDbss) {
      promises.push(MetadataActions.codes.fetchSubscriberCategoryRequirementsPromise(dispatch));
    }
    return $q.all(promises).then(function () {
      var state = $ngRedux.getState();
      var subscriberRequirements = MetadataSelectors.codes.SubscriberRequirementsForCurrentBusinessUnitOrDefault(state);
      var subscriberCategoryRequirements = MetadataSelectors.codes.SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(state);
      setRequirements(subscriberRequirements);
      if (isDbss) {
        setRequirements(subscriberCategoryRequirements);
      }
      fetchRequiredCodes();
    });
  };
};